import React, { createContext, useCallback, useContext, useState } from 'react';
import {
  detectBargain,
  detectTranslations,
  isBargainExpired,
  isBargainStarted,
  isBargainStopped,
} from 'app/BargainWidget/Bargains/utils/bargain-utils';
import useCurrentProductVariant from 'app/BargainWidget/hooks/useCurrentProductVariant';

export const BargainContext = createContext(null);

export const BargainContextProvider = ({children, ...props}) => {
  const {currentVariant} = useCurrentProductVariant();
  const bargainData = detectBargain(window?.bargain?.bargainRules, currentVariant?.productId, currentVariant?.variantId, currentVariant?.collections);
  const hasBargainData = Boolean(bargainData?.id);

  const shopSettings = window?.bargain?.config?.shopSetting;
  const widgetSettings = window?.bargain?.config?.widgetSettings;
  const translation = detectTranslations(window?.bargain?.config?.translations, widgetSettings);

  const customer = window?.bargain?.customer;
  const isCustomerLoggedIn = customer?.id || customer?.email || window?.bargain?.isCustomeLoggedIn;
  const isGuestBargainOfferAllowed = !isCustomerLoggedIn && window?.bargain?.config?.widgetSettings?.loginMandatory !== true;

  const isBargainRuleStarted = isBargainStarted(bargainData);
  const isBargainRuleExpired = isBargainExpired(bargainData);
  const isBargainRuleStopped = isBargainStopped(bargainData);
  const hideActionItems = !isBargainRuleStarted || isBargainRuleExpired || isBargainRuleStopped;
  const isShowBargainWidgetAndButton = hasBargainData && !isBargainRuleStopped && !isBargainRuleExpired && currentVariant?.variantId;

  console.log("isShowBargainWidgetAndButton: ",isShowBargainWidgetAndButton);
  console.log("hasBargainData: ",hasBargainData);
  console.log("currentVariant: ",currentVariant);


  const [showWidgetOnPopup, setShowWidgetOnPopup] = React.useState(false);
  const handleShowWidgetOnPopup = useCallback(() => setShowWidgetOnPopup(prevState => !prevState), []);
  const [showHistoryPopup, setShowHistoryPopup] = React.useState(false);
  const [showLoginPopUp, setShowLoginPopup] = React.useState(false);


  const [modalView, setModalView] = useState(null); /* widget || auth || history || offer_accepted */
  const handleChangeModalView = useCallback((type) => setModalView(type), []);
  const handleCloseModalView = useCallback(() => setModalView(null), []);
  const handleAuthentication = () => handleChangeModalView('auth');

  const [acceptedOfferData, setAcceptedOfferData] = React.useState(null);

  return (
    <BargainContext.Provider
      value={{
        hasBargainData,
        bargainData,
        shopSettings,
        widgetSettings,
        translation,
        customer,
        isBargainRuleStarted,
        isBargainRuleExpired,
        isBargainRuleStopped,
        isShowBargainWidgetAndButton,
        hideActionItems,
        showWidgetOnPopup,
        setShowWidgetOnPopup,
        handleShowWidgetOnPopup,
        currentVariant,
        isCustomerLoggedIn,
        showHistoryPopup,
        setShowHistoryPopup,
        showLoginPopUp,
        setShowLoginPopup,

        modalView,
        setModalView,
        handleChangeModalView,
        handleCloseModalView,
        handleAuthentication,

        acceptedOfferData,
        setAcceptedOfferData,
        isGuestBargainOfferAllowed
      }}
    >
      {children}
    </BargainContext.Provider>
  );
};

export const useBargain = () => {
  const context = useContext(BargainContext);
  if (!context) {
    console.error('error on bargain context!');
  }
  return context;
};
